<template>

  <el-form
    ref='loginForm'
    :model='loginForm'
    :rules='loginRules'
    class='login-form'
    auto-complete='on'
    label-position='left'
  >
    <!-- 点击切换图片 -->
    <!--    <img-->
    <!--      v-if="logWayIcon"-->
    <!--      src="https://static.icarephone.com/mp/new/ocm5/images/orcode.png"-->
    <!--      alt="微信扫码登录点这里"-->
    <!--      class="Qrcode"-->
    <!--    />-->
    <!--    <img-->
    <!--      v-else-->
    <!--      src="https://static.icarephone.com/mp/new/ocm5/images/computer.png"-->
    <!--      alt="密码登录点这里"-->
    <!--      class="Qrcode"-->
    <!--    />-->
    <!-- 扫码登录提示 -->
    <!--    <img-->
    <!--      v-if="logWayTip"-->
    <!--      src="https://static.icarephone.com/mp/new/ocm5/images/ptowe.jpg"-->
    <!--      alt-->
    <!--      class="ptowe"-->
    <!--    />-->
    <!-- 密码登录提示 -->
    <!--    <img v-else src="https://static.icarephone.com/mp/new/ocm5/images/wetop.jpg" alt class="wetop" />-->
    <!-- 密码登录 -->
    <div v-if='logWay' class='loginMain'>
      <span class='title'>账号登录</span>
      <el-form-item prop='login_name'>
        <span class='svg-container'>
          <svg-icon icon-class='userN' />
        </span>

        <el-input
          v-model='loginForm.login_name'
          type='text'
          auto-complete='on'
          clearable
          placeholder='请输入账号'
        />
      </el-form-item>
      <el-form-item prop='password'>
        <div class='captchaLeft'>

          <span class='svg-container'>
            <svg-icon icon-class='captchaN' />
          </span>
          <el-input v-model='loginForm.password'
                    type='password'
                    placeholder='请输入密码'
                    clearable />
        </div>
        <!-- <el-button :disabled="isSendCode > 0" style="float: right; height: 53px;" @click="getMessage">{{ isSendCode > 0 ? `${isSendCode}秒后重新获取` : '获取短信验证码' }}</el-button> -->
      </el-form-item>
      <el-form-item class='loginBtn'>
        <el-button
          :loading='loading'
          type='primary'
          style='width:100%;float: left'
          @click.native.prevent='handleLogin'
        >登录
        </el-button>
        <!--        <el-button-->
        <!--                type="success"-->
        <!--                style="width:40%;float: right"-->
        <!--                @click.native.prevent="handleRegister"-->
        <!--        >注册</el-button>-->
      </el-form-item>
    </div>
    <!-- 扫码登录 -->
    <div v-else class='loginMain'>
      <span class='title'>扫码登录</span>
      <div class='login-wrap'>
        <img :src='qrcodeUrl' alt='扫码登录' class='erweima' />
        <div class='error-tip' v-show='error'>
          <p>{{ error }}</p>二维码链接失效，请
          <a href='javascript:;' @click='reload'>刷新页面</a>重试
        </div>
      </div>
      <p class='wxLogin'>微信扫码登录</p>
    </div>

  </el-form>



</template>


<script>

import { setCookie, removeCookie, getToken } from '@/utils/auth'

export default {
  name: 'reLogin',
  data() {

    const validateUsername = (rule, value, callback) => {
      if (value.length < 1) {
        callback(new Error('请输入账号'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }

    const loginForm = {
      login_name: '',
      password: ''
    }
    return {
      pwdShow: true,
      logWayIcon: true,
      logWayTip: true,
      logWay: true,
      loginForm: loginForm,
      captchaImg: '',
      loginRules: {
        login_name: [
          { required: true, trigger: 'blur', validator: validateUsername },
          { max: 20, message: '输入的文字过长，长度应在 20 个字符内', trigger: 'blur' }
        ],
        password: [
          { required: true, trigger: 'blur', validator: validatePassword },
          { max: 20, message: '输入的文字过长，长度应在 20 个字符内', trigger: 'blur' }
        ]
      },
      loading: false,
      redirect: undefined,
      isSendCode: 0,
      loginWs: undefined,
      xid: '',
      qrcodeUrl: '',
      timeInt: undefined,
      error: ''

    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created() {
    // 登录状态下跳转到首页
    let token = getToken()
    if (token) {
      this.$router.push({ path: '/' })
    }
  },
  methods: {
    // 获取短信验证码
    getMessage() {
      if (!this.$base.isMobile(this.loginForm.mobile, '请填写正确的手机号码'))
        return
      if (this.isSendCode > 0) return
    },
    // 设置验证码倒计时
    setCodeTime(time) {
      this.isSendCode = time
      let interTime = setInterval(() => {
        if (this.isSendCode > 0) {
          this.isSendCode--
        } else {
          removeCookie('loginCode')
          clearInterval(interTime)
        }
      }, 1000)
    },
    logToggle: function() {
      // this.$notify({
      //   title: '提示',
      //   type: 'warning',
      //   message: '扫码登录正在开发中，敬请期待'
      // })
      this.logWay = !this.logWay
    },
    // 获取登录二维码，连接socket
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store
            .dispatch('Login', this.loginForm)
            .then((res) => {
              this.loading = false
              this.$router.push({ path: '/' })
              setCookie('agency_id', res.result.agency_id)
              setCookie('id', res.result.id)
              setCookie('type', res.result.type)
              setCookie('phone', res.result.phone)
              setCookie('name', res.result.name)
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          //this.$message.warning('账号密码错误')
          return false
        }
      })
    },
    handleRegister() {
      // console.log("点击注册")
      let routeUrl = this.$router.resolve({ path: '/register' })
      window.open(routeUrl.href, '_blank')
    },
    reload() {
      window.location.reload()
    }
  }
}
</script>


<style lang='scss' scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;
.Qrcode {
  cursor: pointer;
  float: right;
  margin-top: 7px;
  margin-right: 7px;
}

.login-form {
  position: absolute;
  right: 50px;
  height: 550px;
  width: 456px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 5px 20px 0px rgba(52, 77, 192, 0.13);
  border-radius: 5px;
  // max-width: 100%;
  // padding: 35px 35px 15px 35px;
  // margin: 120px auto;
  .captcha {
    border: none;
    background: none;

    .captchaLeft {
      display: inline-block;
      border: 1px solid #eee;
      border-radius: 5px;
      width: 100%;
    }

    .el-input {
      background: #fff;
      width: 100%;;
    }

    img {
      cursor: pointer;
      position: absolute;
      // padding:1px;
      // border: 1px solid #eee;
      // border-radius: 5px;
      right: 0;
      height: 47px;
      width: 120px;
    }
  }
}

.ptowe {
  float: right;
  margin-top: 20px;
  margin-right: 20px;
}

.wetop {
  float: right;
  margin-top: 20px;
  margin-right: 20px;
}

.svg-container {
  padding: 6px 5px 6px 15px;
  color: $dark_gray;
  vertical-align: middle;
  width: 30px;
  display: inline-block;
}

.title {
  display: inline-block;
  font-family: Microsoft YaHei;
  color: rgba(64, 158, 255, 1);
  font-size: 26px;
  margin-bottom: 20px;
}

.loginMain {
  position: absolute;
  width: 100%;
  padding: 40px;
  top: 50px;

  .erweima {
    width: 240px;
  }

  .login-wrap {
    position: relative;
  }

  .error-tip {
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -120px;
    /*flex 布局*/
    display: flex;
    /*实现垂直居中*/
    align-items: center;
    /*实现水平居中*/
    justify-content: center;
    text-align: justify;
    font-size: 12px;
    width: 240px;
    height: 240px;
    background: rgba(255, 255, 255, 0.8);

    a {
      padding: 0 2px;
      color: red;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.show-pwd {
  position: absolute;
  right: 10px;
  top: 7px;
  font-size: 16px;
  color: $dark_gray;
  cursor: pointer;
  user-select: none;
}
</style>

